const SET_SELECTED_CARD_FOR_NEW_ASMT = 'assignments/SET_SELECTED_CARD_FOR_NEW_ASMT';
const SET_ASSIGNMENT_STATS = 'assignments/SET_ASSIGNMENT_STATS';
const REMOVE_ASSIGNMENT = 'assignments/REMOVE_ASSIGNMENT';
const UPDATE_ASSIGNMENT = 'assignments/UPDATE_ASSIGNMENT';
const SET_ASSIGNMENTS = 'assignments/SET_ASSIGNMENTS';
const ADD_ASSIGNMENTS = 'assignments/ADD_ASSIGNMENTS';
const ADD_ASSIGNMENT = 'assignments/ADD_ASSIGNMENT';
const SET_CARD_PAGES = 'assignments/SET_CARD_PAGES';
const SET_SELECTED = 'assignments/SET_SELECTED';
const SET_PROPERTY = 'assignments/SET_PROPERTY';

export default {
  SET_SELECTED_CARD_FOR_NEW_ASMT,
  SET_ASSIGNMENT_STATS,
  REMOVE_ASSIGNMENT,
  UPDATE_ASSIGNMENT,
  SET_ASSIGNMENTS,
  ADD_ASSIGNMENTS,
  ADD_ASSIGNMENT,
  SET_CARD_PAGES,
  SET_SELECTED,
  SET_PROPERTY,
};



// WEBPACK FOOTER //
// ./src/app/assignments/store/mutation-types.js